import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { guides } from './guides';

export interface IGuide {
  key: string;
  title: string;
  link: string;
  group: Array<string>;
  isWatched?: boolean;
  domain?: Array<string>;
}

export interface ISiteGuide {
  all: Array<IGuide>;
  relatedGuideKeys: Array<string>;
  toViewGuide?: string;
}
export const initialSiteGuide: ISiteGuide = {
  all: guides() ?? [],
  relatedGuideKeys: [],
};

const siteGuideSlice = createSlice({
  name: 'siteGuide',
  initialState: initialSiteGuide,
  reducers: {
    addGuideToList: (state, action: PayloadAction<string | Array<string>>) => {
      state.relatedGuideKeys = [
        ...(typeof action.payload === 'string'
          ? [action.payload]
          : action.payload),
        ...state.relatedGuideKeys,
      ].filter((value, index, array) => {
        return array.indexOf(value) === index;
      });
    },
    viewGuide: (state, action: PayloadAction<string | undefined>) => {
      state.toViewGuide = action.payload;
      if (action.payload)
        state.relatedGuideKeys = [action.payload, ...state.relatedGuideKeys];
    },
    addWatched: (state, action: PayloadAction<string | Array<string>>) => {
      const watchedList = localStorage.getItem('watchedGuides');

      if (watchedList) {
        localStorage.setItem(
          'watchedGuides',
          JSON.stringify([...(JSON.parse(watchedList) || []), action.payload])
        );
      } else {
        localStorage.setItem('watchedGuides', JSON.stringify([action.payload]));
      }

      state.all = state.all.map((item) => {
        if (item.key === action.payload) {
          return {
            ...item,
            isWatched: true,
          };
        } else return item;
      });
    },
  },
});

export const { addGuideToList, addWatched, viewGuide } = siteGuideSlice.actions;

export default siteGuideSlice.reducer;
